import { cn } from "@/lib/utils";

export type ChatMessage = {
  id: string;
  role: "user" | "assistant";
  text: string;
  timestamp?: number;
};

export function MessageBubble({ message }: { message: ChatMessage }) {
  const isUser = message.role === "user";
  return (
    <article
      aria-label={isUser ? "Your message" : "Assistant message"}
      className={cn("flex w-full", isUser ? "justify-end" : "justify-start")}
    >
      <div
        className={cn(
          "max-w-[80%] rounded-xl px-3 py-2 text-[15px] leading-6",
          isUser
            ? "bg-[var(--surface-overlay)] text-[var(--text-primary)]"
            : "border border-[var(--border-subtle)] text-[var(--text-primary)]",
        )}
      >
        {message.text.split("\n").map((line, i) => (
          <p key={i} className={i > 0 ? "mt-2" : ""}>
            {line}
          </p>
        ))}
      </div>
    </article>
  );
}
